module.exports = __webpack_public_path__ + "img/class-test.120c08b3.png";